import { ThunkAction } from 'redux-thunk';
import { Action, Dispatch, ActionCreator } from 'redux';

import { AppState } from '../index';
import { Action as FetchAction, ActionTypes } from './types';

import { getOnboarding } from '../../services/onboarding';

import Video from '../../interfaces/video';

export const fetchOnboarding: ActionCreator<ThunkAction<void, AppState, null, Action<FetchAction>>> = () => (
  dispatch: Dispatch<FetchAction>,
): void => {
  dispatch({
    type: ActionTypes.FETCH,
  });

  getOnboarding().then(
    (videos: Video[]) => {
      dispatch({
        type: ActionTypes.FETCH_SUCCESS,
        videos,
      });
    },
    () => {
      dispatch({
        type: ActionTypes.FETCH_ERROR,
      });
    },
  );
};

export const resetState: ActionCreator<ThunkAction<void, AppState, null, Action<FetchAction>>> = () => (
  dispatch: Dispatch<FetchAction>,
): void => {
  dispatch({
    type: ActionTypes.RESET_STATE,
  });
};
